import React from "react";
import "../styles/QrModal.css";
import NextButton from "../icons/SignInIcon/NextButton";

function QrModal({ open, qrBase64, onClose }) {
  if (!open) return null;

  return (
    <div className="qr-enroll-overlay">
      <div className="qr-enroll-header">
        <div className="qr-enroll-qr-box">
          {qrBase64 && (
            <img
              src={`data:image/png;base64,${qrBase64}`}
              alt="MFA QR Code"
              style={{ width: 200, height: 200 }}
            />
          )}
        </div>

        <div className="qr-code-enroll-text">
          Use your authenticator app to scan the QR code.
          <div className="text-connected">
            This connects the app to your account.
          </div>
        </div>
        <div className="qr-code-banner">
          <div className="container-text">
            <div className="come-back-text">
              Then come back and select Next.
            </div>
          </div>
        </div>
        <div className="qr-linked-action">
          <div className="qr-code-enroll-link">Can’t scan the QR code?</div>
        </div>

        <div className="qr-enroll-action" onClick={onClose}>
          <div className="qr-button">
            <NextButton />
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrModal;
